import { useEffect, useState } from "react";
/**
 * @export
 *
 * Hook to check if a fontawesome icon is ready
 */
export const useIsFAIconReady = (icon) => {
    const [ready, setReady] = useState(false);
    const IconLibrary = typeof window !== 'undefined' ? window.IvivaFontAwesomIconLibrary : null;
    useEffect(() => {
        if (!IconLibrary) {
            // If library is not available, show the icon anyway (fallback)
            setReady(true);
            return;
        }
        // Check if icon is immediately available
        if (IconLibrary.hasIcon(icon)) {
            setReady(true);
            return;
        }
        // Subscribe to icon availability
        const unsubscribe = IconLibrary.subscribeToIcon(icon, (available) => {
            if (available) {
                setReady(true);
            }
        });
        // Cleanup subscription on unmount
        return unsubscribe;
    }, [IconLibrary, icon]);
    return ready;
};
